export default __webpack_public_path__ + "static/media/italian_flag.f7b1c5e7.webp";